import styled from "styled-components";

export const PaginationWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: 0;
`;
